import firebase from "firebase/app";
import { projectAuth } from "@/firebase/config";

const provider = new firebase.auth.GoogleAuthProvider();

let error = {};

const login = async (email, password) => {
  try {
    const res = await projectAuth.signInWithEmailAndPassword(email, password);
    return res;
  } catch (e) {
    console.error(e.value);
  }
};

const loginWithGoogle = async () => {
  try {
    console.log(provider);
    const res = await firebase.auth().signInWithRedirect(provider);
    console.log(res);
    return res;
  } catch (e) {
    console.error(e.value);
  }
};

const useLogin = () => {
  return { error, login, loginWithGoogle };
};

export default useLogin;
